import React, { useEffect, useRef, useState } from 'react';
import Box from 'src/component/Box.component';
import './style.css';

const LoadingWrapper = ({
  children = null,
  loading = false,
  principal = 'Procesando',
  secundario = '',
  height = '90vh',
  fontSize='40px',
  width='30px',
  style={}
} = {}) => {
  const ref = useRef(null);
  const [color, setColor] = useState('');
  
  useEffect(() => {
    if(ref &&  ref.current) {
      ref.current.style.setProperty("height", height, "important");
    }
    
  },[height])

  

  if (!loading) {
    return children;
  }

 

  return (
    <React.Fragment>
      <div className="container-fluid vh-100"  ref={ref}>
        <div className="row justify-content-center h-100" style={style}>
          <div className="col-12 text-center align-self-center">
            <h3 style={{ fontSize: fontSize }}>{principal}</h3>
            <div className="spinner" >
              <Box bg="textColor1"  mx={2} className="bounce1" style={{width: width + ' !important'}}></Box>
              <Box bg="textColor1"  mx={2} className="bounce2" style={{width: width + ' !important'}}></Box>
              <Box bg="textColor1"  mx={2} className="bounce3" style={{width: width + ' !important'}}></Box>
              <Box bg="textColor1"  mx={2} className="bounce4" style={{width: width + ' !important'}}></Box>
              <Box bg="textColor1"  mx={2} className="bounce5" style={{width: width + ' !important'}}></Box>
            </div>
            <h5>{secundario}</h5>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoadingWrapper;
